module.exports = __webpack_public_path__ + "img/whychose2.20850d31.svg";